// backgrounds.js

export const backgrounds = {
  Bárbaro: "https://www.artstation.com/juliosidharta",
  Bardo: "https://www.artstation.com/justingerardillustration",
  Bruxo: "https://www.artstation.com/billcreative",
  Clérigo: "https://www.artstation.com/martanael",
  Druida: "https://www.deviantart.com/huussii",
  Feiticeiro: "https://rare-gallery.com/350727-4k-wallpaper.html",
  Guerreiro: "https://www.artstation.com/1999",
  Ladino: "https://www.artstation.com/enricoottini",
  Mago: "https://www.artstation.com/htartist",
  Monge: "https://www.artstation.com/voyagerillustration",
  Paladino: "https://www.artstation.com/casondralogan",
  Patrulheiro: "https://www.artstation.com/klokkeblomst",
  // Adicione mais backgrounds para outras classes, se necessário
};
